import cartStore from '../../../store/cartStore'
import {
  apiMove,
  apiProducts,
  apiDeleteCart,
} from '../../../services/cartApi'
import ProductModel from '../models/ProductModel'
import Routing from 'fos-router'
import routes from '../../../../../../CustomerBundle/public/js/data/fos_js_routes'
import { resolveProductFromGlobals } from './productSource'
import { createProductStoreService } from './productStoreService'
import { createDeliveriesService, formatDateKey, formatDateLabel, UNKNOWN_DATE_KEY, invalidateDeliveries } from './productDeliveriesService'
import { createTotalsService } from './productTotalsService'
import { createArticleService } from './productArticlesService'
import { createMoveProductsService } from './productMoveService'
import { createDeleteService } from './productDeleteService'
import { getCheckboxState } from '../../../utils/checkboxStorage'

const storeService = createProductStoreService({
  store: cartStore,
  apiProducts,
  getProductByArticle: resolveProductFromGlobals,
  getCheckboxState,
})

const generateProductUrl = (productId) => {
  try {
    Routing.setRoutingData(routes)
    return Routing.generate('product_show', { id: productId })
  } catch (e) {
    return '#'
  }
}

// Возвращает список cart-записей, у которых нет доступных остатков или цена = 0.
// Признак: deliveriesByCart[product.id] отсутствует или totalAmount === 0,
// либо cart.price === 0 (товар недоступен для заказа).
// cart.amount <= 0 — позиция уже удалена (маркер -1 для undo либо 0 после
// локального удаления из OOS), её не включаем.
const getOutOfStockProducts = () => {
  const deliveriesByCart = cartStore.deliveriesByCart && typeof cartStore.deliveriesByCart === 'object'
    ? cartStore.deliveriesByCart
    : {}

  const result = []
  cartStore.productCollection.getAll().forEach(cart => {
    if (typeof cart.amount !== 'number' || cart.amount <= 0) {
      return
    }

    const price = typeof cart.price === 'number' ? cart.price : parseFloat(cart.price)
    if (price === 0) {
      result.push(cart)
      return
    }
    const entry = deliveriesByCart[cart.product.id]
    const totalAmount = entry && typeof entry.totalAmount === 'number' ? entry.totalAmount : 0
    if (!entry || totalAmount === 0) {
      result.push(cart)
    }
  })
  return result
}

const deliveriesService = createDeliveriesService({
  store: cartStore,
  routing: Routing,
  routes,
  ProductModel,
})

const totalsService = createTotalsService({
  getDeliveries: deliveriesService.getDeliveries,
})

const articleService = createArticleService({
  store: cartStore,
})

const moveService = createMoveProductsService({
  apiMove,
})

const deleteService = createDeleteService({
  apiDeleteCart,
})

const { loadProductsToStore, addProductToStore } = storeService
const { getDeliveries } = deliveriesService
const { getTotalInfoByArticleList } = totalsService
const { getAllArticles, getActiveArticles } = articleService
const { moveProducts } = moveService
const { processDeleting } = deleteService

export {
  loadProductsToStore,
  getDeliveries,
  getOutOfStockProducts,
  generateProductUrl,
  invalidateDeliveries,
  formatDateKey,
  formatDateLabel,
  UNKNOWN_DATE_KEY,
  getTotalInfoByArticleList,
  getAllArticles,
  getActiveArticles,
  moveProducts,
  addProductToStore,
  processDeleting,
}
